import React, { useCallback, useMemo, useRef } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { SelectTagWidgetContainer } from "../../BroadcastView.styles";
import {
  BroadcastAppCard,
  Container,
  ContainerActions,
  FormContainer,
  InfoAlert,
} from "../styles";
import { BroadcastActionItem } from "./broadcast-action-item";
import { BackLink } from "../../Campaigns.style";
import Button from "../../../../../components/shared/components/button/Button.style";
import { broadcastActionsSchema } from "../shemas/broadcast";

export const BroadcastActionsForm = ({
  handleNext,
  handleBack,
  updateBroadcastData,
  broadcastData,
}) => {
  const { buttons, actions } = broadcastData;

  const mediaFilesRef = useRef({});

  const defaultValues = useMemo(() => {
    if (actions && actions.length > 0) return actions;

    return (buttons || []).map((button) => ({
      label: button.text,
      agents: [],
      tags: [],
    }));
  }, [buttons, actions]);

  const {
    control,
    register,
    handleSubmit,
    errors,
  } = useForm({
    validationSchema: broadcastActionsSchema,
    defaultValues: { actions: defaultValues },
    mode: "onChange",
  });

  const { fields } = useFieldArray({ control, name: "actions" });

  const handleMediaFileChange = useCallback((index, file) => {
    mediaFilesRef.current[index] = file ?? null;
  }, []);

  const onSubmit = (data) => {
    const actions = data.actions.map((action, index) => {
      const mediaFile = mediaFilesRef.current[index] ?? null;
      const hasMedia = Boolean(mediaFile);

      const base = {
        label: action.label,
        agents: action.agents ?? [],
        tags: action.tags ?? [],
      };

      if (hasMedia) {
        return { ...base, mediaFile };
      }

      const trimmedMessage = action.message ? action.message.trim() : "";
      if (trimmedMessage) {
        return { ...base, message: trimmedMessage };
      }

      return base;
    });

    updateBroadcastData({ actions });
    handleNext();
  };

  const handleOnBack = () => {
    handleBack({ actions: defaultValues });
  };

  return (
    <SelectTagWidgetContainer>
      <BroadcastAppCard>
        <Container>
          <FormContainer onSubmit={handleSubmit(onSubmit)}>
            <InfoAlert>
              Para agregar, eliminar o cambiar el texto de los botones, debes editar la plantilla de
              WhatsApp directamente. Aquí solo puedes configurar las acciones para los botones
              existentes.
            </InfoAlert>

            {fields.map((field, index) => (
              <BroadcastActionItem
                key={field.id}
                index={index}
                control={control}
                register={register}
                errors={errors}
                action={field}
                onMediaFileChange={handleMediaFileChange}
              />
            ))}

            {fields.length === 0 && (
              <div style={{ textAlign: "center", color: "#6b7280", padding: "2rem" }}>
                No hay botones configurados en esta plantilla.
              </div>
            )}
          </FormContainer>
        </Container>

        <ContainerActions>
          <BackLink onClick={handleOnBack}>← Atrás</BackLink>
          <Button designV4 type="submit" onClick={handleSubmit(onSubmit)}>
            Continuar
          </Button>
        </ContainerActions>
      </BroadcastAppCard>
    </SelectTagWidgetContainer>
  );
};
